import { FontColorEnum, FontSizeEnum, FontWeightEnum, Typography } from '@acceso/design-system';
import { ReactNode } from 'react';

type TSwitchButtonProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  iconOn?: ReactNode;
  iconOff?: ReactNode;
};

export function SwitchButton({ checked, onChange, label, iconOn, iconOff }: TSwitchButtonProps) {
  const handleToggle = () => onChange(!checked);

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      onClick={handleToggle}
      className="group inline-flex select-none items-center gap-2.5 rounded-[4px] border border-accent-active-primary-40 bg-accent-neutral-00 px-2.5 py-1 transition-all duration-200 hover:border-accent-active-primary-30 hover:!bg-neutral-20 focus:outline-none focus-visible:ring-2 focus-visible:ring-custom-dark-blue/40"
    >
      <span
        className={[
          'relative inline-flex h-6 w-11 items-center rounded-[4px] transition-colors duration-300 ease-in-out',
          checked ? 'bg-feedback-success-20' : 'bg-text-medium-10',
        ].join(' ')}
      >
        <span
          className={[
            'absolute top-0.5 flex h-5 w-5 items-center justify-center rounded-[2px] bg-white shadow-md transition-transform duration-300 ease-in-out',
            checked ? 'translate-x-[22px]' : 'translate-x-0.5',
          ].join(' ')}
        >
          {(checked ? iconOn : iconOff) ? (
            <span
              className={[
                'flex h-3.5 w-3.5 items-center justify-center transition-colors duration-300',
                checked ? 'bg-feedback-success-20' : 'text-slate-500',
              ].join(' ')}
            >
              {checked ? iconOn : iconOff}
            </span>
          ) : (
            <span
              className={[
                'h-2 w-2 rounded-[1px] transition-colors duration-300',
                checked ? 'bg-feedback-success-20' : 'bg-text-medium-10',
              ].join(' ')}
            />
          )}
        </span>
      </span>
      <Typography
        fontSize={FontSizeEnum.Xs}
        weight={FontWeightEnum.Semibold}
        color={FontColorEnum.ActivePrimary}
        className="text-center"
      >
        {label}
      </Typography>
    </button>
  );
}
